module.exports = __webpack_public_path__ + "static/media/TH.00b55d2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/TH.svg
// module id = 372
// module chunks = 0